var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-page"},[_c('h2',[_vm._v("Admin sidan")]),(_vm.admin.dataCollection.view)?_c('DataCollection'):_vm._e(),(_vm.admin.settings.view)?_c('AdminSettings'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }